import { postMediaUrl } from '@/api/mediaAPI'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { useQuery } from '@tanstack/react-query'

function DirectDownload({ path }: { path: string }) {
  const { data } = useQuery({
    queryKey: ['media_url', path],
    queryFn: () =>
      postMediaUrl({
        key: path,
        isPrivate: 'true',
      }),
    staleTime: 5 * 60 * 1000,
  })

  return (
    <div className={'p-2'} style={{ marginRight: '-0.6rem' }}>
      <a href={data} rel="noreferrer" target="_BLANK">
        <ArrowDownTrayIcon className={'h-5 w-5 text-black'} />
      </a>
    </div>
  )
}

export default DirectDownload
